<template>
  <div>
    <div class="">
      <div class="mt-4 ms-3 text-start">
        <strong class="w-100 mb-4">Carga de renovaciones masivas</strong>
        <p>Proceso Masivo</p>
      </div>
      <div class="mx-3">
        <div class="row gx-1 gy-2">
          <div class="col-3">
            <p class="text-start mt-2 my-1">1.Opciones</p>
            <div class="d-flex flex-wrap gap-2">
              <button class="btn btn-secondary btn-sm" @click="CargaTrabajadores"
                title="Opción para cargar trabajadores que pasarán por una nueva renovación">
                <i class="bi bi-database-up"></i>
              </button>

              <button class="btn btn-success btn-sm"
                title="Opción para ir a una renovación INDIVIDUAL de trabajadores"
                @click="$router.push('RegistroRenovaciones')">
                <i class="bi bi-person"></i>
              </button>

              <button class="btn btn-danger text-white btn-sm"
                title="Opcion para eliminar renovacion masiva" @click="EliminarMasivo">
                <i class="bi bi-trash3"></i>
              </button>

              <button class="btn btn-secondary btn-sm" @click="BuscarAccionRenMasivo(MarcarDesmarcar())"
                title="Opción para renovación de uno o más trabajadores">
                <i
                  :class="ultimoEstadoMarcado == 1 ? 'bi bi-check-square' : 'bi bi-check-square-fill'"></i>
              </button>

              <button class="btn btn-warning btn-sm" @click="MarcarSSC" title="MARCAR POR SSCC">
                <i class="bi bi-building-fill-check"></i>
              </button>

              <button @click="descargarExcel" :class="{
                'btn btn-success border-dark border-2 btn-sm text-white text-nowrap':
                  !excelCarga,
                'btn btn-light border-dark border-2 btn-sm text-success text-nowrap':
                  excelCarga,
              }" :disabled="!excelCarga">
                <i class="bi bi-filetype-xls"></i>
                <b v-if="excelCarga">Descargar Lista </b>
                <b v-else>Cargando...</b>
              </button>
            </div>
          </div>

          <div class="col col-9">
            <h6 class="w-100 text-start my-1 py-1 ms-3">
              Filtros de búsqueda:
            </h6>
            <div class="">
              <b-row>
                <b-col cols="4">
                  <b-form-group>
                    <b-input class="p-1" id="searchInput1" v-model.trim="Dni" placeholder="POR DOC. IDENTIDAD"
                      @input="Dni = Dni.replace(/\s+/g, ''); resetPagina()"></b-input>
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-form-group>
                    <b-input class="p-1" id="searchInput2" v-model.trim="Apellidos" placeholder="POR APELLIDOS"
                      @input="Apellidos = Apellidos.replace(/^\s+/, ''); resetPagina()"></b-input>
                  </b-form-group>
                </b-col>

                <b-col cols="4">
                  <b-form-group>
                    <b-input class="p-1" id="searchInput2" v-model.trim="SubSubCentro" placeholder="POR SCC"
                      @input="SubSubCentro = SubSubCentro.replace(/^\s+/, ''); resetPagina()"></b-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </div>

          <div class="col-12">
            <div class="col-12 d-flex justify-content-start mt-4">
              <button title="visualizar" @click="opcion = !opcion" class="btn btn-light fs-5 py-2">
                <i class="bi bi-chevron-compact-down"></i>
              </button>
            </div>

            <div v-if="opcion">
              <p class="mx-1 mt-2 text-start tamaño">
                Las opciones presentadas acontinuación pueden ser llenadas en su
                totalidad si los trabajadores escogidos o marcados cumplen con
                las mismas características(Puesto, Sueldo, Fec. Fin) en una
                renovación.De ser el caso que estas características sean
                distintas no deben de ser llenadas.
              </p>

              <div class="tamaño row gx-3 gy-3">
                <div class="col-3">
                  <label for="">Empresa</label>
                  <select class="form-control tamaño text-center py-1" @change="CentroCostoMasivo($event)" disabled>
                    <option disabled selected>-</option>
                    <option v-for="empresa in DniEmpre" :key="empresa.id" :value="empresa.id">
                      {{ empresa.empNomCorto }}
                    </option>
                  </select>
                </div>

                <div class="col-3">
                  <label for="">Centro Costo</label>
                  <select class="form-control tamaño text-center py-1" @change="SubCentroCostoMasivo($event)" disabled>
                    <option class="text-center" disabled selected>-</option>
                    <option v-for="centro in CentroDeCostoMasivo" :key="centro.id" :value="centro.cenCodigo">
                      {{ centro.cenNombre }}
                    </option>
                  </select>
                </div>

                <div class="col-3">
                  <label for="">Sub Centro</label>
                  <select class="form-control tamaño text-center py-1" @change="SubSubCentroDeCostosMasivo($event)"
                    disabled>
                    <option disabled selected>-</option>
                    <option v-for="subCentro in SubCentroDeCostoMasivo" :key="subCentro.id"
                      :value="subCentro.cenSubCentro">
                      {{ subCentro.cenNombre }}
                    </option>
                  </select>
                </div>

                <div class="col-3">
                  <label for="">Sub Sub Centro</label>
                  <select class="form-control tamaño text-center py-1" @change="SubSubCentroCostosMandaMasivo($event)"
                    disabled>
                    <option disabled selected>-</option>
                    <option v-for="subCen in SubSubCentroDeCostoMasivo" :key="subCen.id"
                      :value="subCen.cenSubSubCodigo">
                      {{ subCen.cenNombre }}
                    </option>
                  </select>
                </div>

                <div class="col-4">
                  <label for="">Puesto</label>
                  <select class="form-control tamaño text-center py-1" @change="PuestoMasivo($event)">
                    <option disabled selected>Seleccionar Opción</option>
                    <option v-for="puestos in puesto" :key="puestos.id" :value="puestos.idPuesto">
                      {{ puestos.ptoNombre }}
                    </option>
                  </select>
                </div>

                <div class="col col-2">
                  <label class="mx-1" for="">Sueldo</label>

                  <input type="text" class="form-control tamaño text-center py-1" id="exampleInputEmail1"
                    aria-describedby="emailHelp" v-model="sueldoMasivo" />
                </div>

                <!-- <div class="col">
<div><label for="">Fecha Inicio</label></div>

<input
v-model="fechaIniMasivo"
class="text-center form-control text-secondary"
type="date"
/>
</div> -->

                <div class="col col-3">
                  <div class="mx-1">
                    <label for="">Fec. Inicio de Renovación</label>
                  </div>

                  <input disabled v-model="fechaIniMasivo" class="text-center form-control tamaño text-secondary py-1"
                    type="text" />
                </div>

                <div class="col col-3">
                  <div class="mx-1">
                    <label for="">Fec. Fin de Renovación</label>
                  </div>

                  <input v-model="fechaFinMasivo" class="text-center tamaño form-control text-secondary py-1"
                    type="date" />
                </div>

                <div class="col container col-4 mt-3">
                  <button @click="CargaMasiva" class="btn btn-success tamaño w-auto w-100 mb-2">
                    <i class="bi bi-save mx-3 fs-5"></i>GENERAR CARGA MASIVA
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mx-3">
      <div class="col col-3">
        <button class="btn btn-danger tamaño border border-2 w-100 mt-2" @click="MarcarTodos">
          MARCAR TODOS
        </button>
      </div>
      <div class="col col-3">
        <button class="btn btn-ligth tamaño border border-2 w-100 mt-2" @click="MarcarSSC">
          MARCAR POR SSC
        </button>
      </div>

      <div class="mt-2 py-0 tamaño container">
        Total de trabajadores : {{ Items.length }}
      </div>
    </div>

    <div class="mt-2 mx-3 table-responsive">
      <table class="table table-bordered">
        <thead class="reducirTamaño">
          <tr class="bg-solimano text-center text-white text-nowrap">
            <th colspan="7">DATOS GENERALES</th>
            <th :colspan="mostrarColumnasIndividuales ? 4 : 1">RENOVACION</th>
            <th colspan="3">HISTORIAL</th>
          </tr>
          <tr class="bg-solimano text-center text-white text-nowrap">
            <th scope="col"><i class="bi bi-check-circle-fill text-white fs-7"></i></th>
            <th scope="col">PERIODO</th>
            <th scope="col">CIUDAD</th>
            <th scope="col">TRABAJADOR</th>
            <th scope="col">CLIENTE</th>
            <th scope="col">PUESTO</th>
            <th scope="col">CONTRATO ACTUAL</th>
            <th scope="col">SUELDO</th>
            <th scope="col" v-if="mostrarColumnasIndividuales">FECHA INICIO</th>
            <th scope="col" v-if="mostrarColumnasIndividuales">FECHA FIN</th>
            <th scope="col" v-if="mostrarColumnasIndividuales">MOTIVO</th>

            <th scope="col">VCTO. DE CONTRATO</th>
            <th scope="col">DIAS TRABAJADOR</th>
            <th scope="col">RECORD TRABAJADORES</th>
          </tr>
        </thead>
        <tbody v-if="Spinner && Items.length == 0">
          <tr>
            <td colspan="20" class="text-center py-5">
              <div class="spinner-border text-primary" role="status"></div>
            </td>
          </tr>
        </tbody>
        <tbody v-else class="align-middle">
          <tr class="text-center align-middle reducirTamaño" v-for="itema in itemsPaginados" :key="itema.id">
            <th class="" scope="row">
              <div class="px-4">
                <div class="">
                  <!-- v-if="itema.accionRen == true" -->
                  <!-- disabled -->

                  <input :disabled="checkcitos" @change="actualizarEstado(itema)" type="checkbox"
                    :value="itema.idRenovacion" v-model="itema.renAccionReg" />
                  <!-- <input
                v-else
                @change="actualizarEstado(itema)"
                type="checkbox"
                :value="itema.idRenovacion"
                v-model="checkeId"
              /> -->
                </div>
              </div>
            </th>

            <td class="text-start fw-bold">
              <div class="d-flex align-items-center gap-2">
                <i class="bi bi-calendar3 text-secondary fs-7"></i>
                <label>{{ itema.periodo }}</label>
              </div>
              <div class="d-flex align-items-center gap-2 mt-1">
                <i :class="{
                  ' bi bi-arrow-clockwise text-primary': itema.renCodEstado == 'EN PROCESO',
                  'bi bi-check-circle-fill text-warning': itema.renCodEstado == 'SOLICITADO',
                  'bi bi-x-circle-fill text-danger': itema.renCodEstado == 'NO RENOVADO',
                }"></i>
                <label :class="{
                  'text-primary': itema.renCodEstado == 'EN PROCESO',
                  'text-warning': itema.renCodEstado == 'SOLICITADO',
                  'text-danger': itema.renCodEstado == 'NO RENOVADO',
                }">
                  {{ itema.renCodEstado }}
                </label>
              </div>
            </td>

            <td class="">{{ itema.departamento }}</td>

            <td class="text-start ">
              <div class="d-flex align-items-center gap-2 fw-bold">
                <i class="bi bi-credit-card-2-front text-success fs-6"></i>
                <label>{{ itema.nroDocumento }}</label>
              </div>
              <div class="d-flex align-items-center gap-2 mt-1">
                <i class="bi bi-person-circle text-primary fs-6"></i>
                <label>{{ itema.nomTrabajador }}</label>
              </div>
            </td>
            <td class="text-start text-nowrap">
              <div class="fw-bold"><i class="bi bi-building me-1"></i>{{ itema.nomEmpresa }}</div>
              <div class="small"><i class="bi bi-diagram-2-fill me-1 text-danger"></i>{{ itema.subCentroCostos }}</div>
              <div class="small"><i class="bi bi-diagram-3-fill me-1 text-info"></i>{{ itema.subSubCentroCostos }}</div>
            </td>

            <td class="text-center align-middle">
              <div class="d-flex flex-column align-items-center"><i class="bi bi-briefcase-fill text-primary mb-1"></i>{{ itema.nomPuesto }}</div>
            </td>

            <td class="px-0 mx-0">
              <div class="d-flex flex-column align-items-center fw-bold text-center py-1">
                <div class="d-flex align-items-center gap-2 mb-1">
                  <i class="bi bi-calendar3 text-warning fs-6"></i>
                  <span v-if="itema.fecIniConActual.slice(0, 10) === '1900-01-01'">-</span>
                  <span v-else>
                    {{ new Date(itema.fecIniConActual).toLocaleDateString('es-ES') }} - {{ new Date(itema.fecFinConActual).toLocaleDateString('es-ES') }}
                  </span>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <i class="bi bi-cash-stack text-success fs-6"></i>
                  <span>ACTUAL: {{ itema.renSueldoActual }}</span>
                </div>
              </div>
            </td>

            <td class="">
              <div class="form-group">
                <p v-if="
                  sueldoFinal >
                  itema.renSueldoActual * 0.2 + itema.renSueldoActual &&
                  from.idRenovacion == itema.idRenovacion
                ">
                  No puedes exceder el 20% del sueldo Actual
                </p>

                <!-- @change="mostrar($event)"
          :value="data.item.renSueldo" -->

                <label for="" class="py-0 fw-semibold">{{ itema.renSueldo }}</label>
              </div>
            </td>

            <td class="align-middle text-center" v-if="mostrarColumnasIndividuales">
              <div class="d-flex align-items-center justify-content-center gap-2">
                <i class="bi bi-calendar-check text-success fs-6"></i>
                <input class="text-center form-control form-control-sm text-secondary" :disabled="!itema.renAccionReg" @change="FechaIni($event)" type="date"
                  :value="itema.fechaIniContrato.slice(0, 10)" />
              </div>
            </td>

            <td class="align-middle text-center" v-if="mostrarColumnasIndividuales">
              <div class="d-flex align-items-center justify-content-center gap-2">
                <i class="bi bi-calendar-x text-danger fs-6"></i>
                <input :disabled="!itema.renAccionReg" class="form-control form-control-sm text-center text-secondary text-center" type="date"
                  :value="itema.fechaFinContrato.slice(0, 10)" />
              </div>
            </td>

            <td class="py-0 my-0" v-if="mostrarColumnasIndividuales">
              <div class="" for="">
                <p class="mb-0 fw-semibold" v-if="itema.motivoRenovacion.length > 0">
                  {{ itema.motivoRenovacion }}
                </p>
                <p class="mb-0 text-muted" v-else>-</p>
              </div>
            </td>

            <td class="">
              <div class="mx-3">
                <label for="" class="text-center fw-semibold">En {{ itema.diasRen }} Días</label>
              </div>
            </td>

            <td class="fw-semibold">{{ itema.diasTrabajador }}</td>

            <td class="">
              <div class="form-group w-auto">
                <div class="d-flex align-items-center justify-content-center gap-1 text-nowrap">
                  <p class="mb-0 fw-bold" v-if="itema.formatoAño.slice(0, 1) == 1">
                    {{ itema.formatoAño }} año
                  </p>
                  <p class="mb-0 fw-bold" v-if="
                    itema.formatoAño.slice(0, 1) != 1 &&
                    itema.formatoAño.slice(0, 1) != 0
                  ">
                    {{ itema.formatoAño }} años
                  </p>
                  <p class="mb-0 fw-bold" v-if="itema.formatoMes.slice(0, 1) == 1">
                    {{ itema.formatoMes }} mes
                  </p>
                  <p class="mb-0 fw-bold" v-if="
                    itema.formatoMes.slice(0, 1) != 1 &&
                    itema.formatoMes.slice(0, 1) != 0
                  ">
                    {{ itema.formatoMes }} meses
                  </p>
                  <p class="mb-0 fw-bold" v-if="itema.formatoDias.slice(0, 1) == 1">
                    {{ itema.formatoDias }} días
                  </p>
                  <p class="mb-0 fw-bold" v-if="
                    itema.formatoDias.slice(0, 1) != 1 &&
                    itema.formatoDias.slice(0, 1) != 0
                  ">
                    {{ itema.formatoDias }} días
                  </p>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="d-flex mt-3">
        <button class="btn btn-dark mx-4" @click="retroceso" :disabled="noRetroceder">
          <span aria-hidden="true">{{ retroceder }}</span>
        </button>
        <button class="text-white px-3 rounded-2 py-2 btn-solimano" :disabled="true">
          {{ pag }} / {{ Math.ceil(this.Items.length / 10) }}
        </button>

        <button class="btn btn-dark mx-4" @click="aumentar" :disabled="noAvanzar">
          <span aria-hidden="true">{{ avanzar }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "SolimanologRegistroRenovacionMasiva",

  data() {
    return {
      Dni: "",
      Apellidos: "",
      SubSubCentro: "",
      sueldoFinal: "",
      Totalkit: [],
      TotalSsc: [],
      excelCarga: false,
      excel: [],
      // fechaFinRen:[],
      checkcitos: false,

      from: {
        idRenovacion: "",
      },
      filter: "",
      filtradoAntes: "",
      perPage: 10,
      totalRows: 1,
      currentPage: 1,
      checkeId: [],
      puesto: [],
      dniUsuario: "",
      CentroDeCostoMasivo: [],
      SubCentroDeCostoMasivo: [],
      idEmpresaMasivo: [],
      SubSubCentroDeCostoMasivo: [],
      cenCodigoCentroMasivo: "",
      cenCodigoSubCentroMasivo: "",
      cenCodigoSubSubCemtroMasivo: "",
      idPuestoMasivo: "0",
      sueldoMasivo: "0",
      fechaIniMasivo: "-",
      fechaFinMasivo: "",
      colorRenovacion: "",

      pag: 1,
      NUM_RESULTS: 10,
      NUM_RESULTS1: 10,
      retroceder: "<<",
      avanzar: ">>",
      noAvanzar: false,
      noRetroceder: false,
      opcion: false,
      ultimoEstadoMarcado: 0,
    };
  },

  created() {
    this.reporteRenovacion();
  },

  mounted() {
    this.dniUsuario = localStorage.getItem("dniUsers");
    this.idTrabajador = localStorage.getItem("idTrabajdor");
    this.totalRows = this.Items.length;
    this.axios.get("ParametroData/Parametro/7634").then((r) => {
      console.log(r.data);
      this.motivo = r.data;
    });

    this.axios.get("PuestoData/ListadoPuesto").then((r) => {
      console.log(r.data);
      this.puesto = r.data;
    });
  },

  computed: {
    ...mapGetters("users", ["DniEmpre"]),
    ...mapGetters("renovaciones", ["Items", "Spinner"]),

    // LOGICA DE FILTRADO LOCAL (IGUAL QUE EN INDIVIDUAL)
    itemsFiltrados() {
      return this.Items.filter(item => {
        const dni = this.Dni.toLowerCase();
        const apellidos = this.Apellidos.toLowerCase();
        const subCentro = this.SubSubCentro.toLowerCase();

        return (
          (!dni || item.nroDocumento?.toLowerCase().includes(dni)) &&
          (!apellidos || item.nomTrabajador?.toLowerCase().includes(apellidos)) &&
          (!subCentro || item.subSubCentroCostos?.toLowerCase().includes(subCentro))
        );
      });
    },

    itemsPaginados() {
      const inicio = this.NUM_RESULTS - 10;
      return this.itemsFiltrados.slice(inicio, this.NUM_RESULTS);
    },

    conteoMarcados() {
      return this.Items.filter(i => i.renAccionReg).length;
    },

    mostrarColumnasIndividuales() {
      return this.conteoMarcados <= 1;
    },
  },

  methods: {
    ...mapActions("renovaciones", ["Renovaciones"]),

    EliminarMasivo() {
      this.axios
        .delete(
          `Renovacion/EliminarRenMasivo?idTrabajador=${this.idTrabajador}`
        )
        .then((r) => {
          console.log(r.data);
          this.Renovaciones();
        });
    },

    reporteRenovacion() {
      console.log("aja");
      this.idTrabajador = localStorage.getItem("idTrabajdor");

      this.excelCarga = false;
      this.axios
        .get(
          `ReportesExcel/RepRenovacioness?idTrabajador=${this.idTrabajador}`,
          { responseType: "blob" }
        )
        .then((response) => {
          this.excelCarga = true;
          this.excel = response.data;
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
          this.excelCarga = true; // IMPORTANTE: Desbloquear el botón si falla la carga
          Swal.fire("Aviso", "No se pudo cargar el reporte automáticamente. Intente recargar.", "warning");
        });
    },

    descargarExcel() {
      var fileURL = window.URL.createObjectURL(new Blob([this.excel]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", "ReporteRenovaciones.xlsx");
      document.body.appendChild(fileLink);

      fileLink.click();
    },

    BuscarAccionRenMasivo() {
      let ArrayMasivo = [];
      this.Items.forEach((item) => {
        ArrayMasivo.push(item.idRenovacion);
      });

      if (ArrayMasivo.length === 0) return;

      try {
        this.axios
          .get(`Renovacion/ValidarEstadosRenovacion?cadena=${ArrayMasivo.join(",")}`)
          .then((response) => {
            this.ultimoEstadoMarcado = response.data;
            // console.log("Estado de las renovaciones:", response.data);
          });
      } catch (error) {
        console.error("Error en la petición", error);
      }
    },

    async MarcarDesmarcar() {
      this.BuscarAccionRenMasivo();
      let valorAMandar = this.ultimoEstadoMarcado;
      let ArrayMasivo = [];
      this.Items.forEach((item) => {
        ArrayMasivo.push(item.idRenovacion);
      });
      // 2. Validamos que el array no esté vacío
      if (ArrayMasivo.length === 0) return;

      if (valorAMandar == 1) {
        valorAMandar = 0; // Desmarcar
      } else if (valorAMandar == 3) {
        valorAMandar = 1; // Normalizar a Marcado
      } else {
        valorAMandar = 1; // Estaba en 0, marcar todo
      }

      // 3. Preparamos el objeto con la nomenclatura que espera tu C#
      const oAccxRen = {
        renAccion: `${valorAMandar}`, // 1 para marcar, 0 para desmarcar
        CadenaRenovacion: ArrayMasivo.join(","), // "1,2,3,4,5"
      };

      try {
        // 4. Llamada a la nueva API (usando PUT)
        const response = await this.axios.put("Renovacion/ModificarAccionxRenMasivo", oAccxRen);

        if (response.data == true) {
          this.ListarRenovaciones();
        } 
      } catch (error) {
        console.error("Error al conectar con la API:", error);
      }
    },

    IntegrarIds() {
      console.log(this.Items);
      for (let index of this.Items) {
        if (index.accionRen == true) {
          this.Totalkit.push(index.idRen);
          console.log(this.Totalkit);
        }
      }
    },
    MarcarTodos() {
      const cadenaMasiva = [];
      this.Items.map((r) => {
        console.log(r.idRenovacion);
        cadenaMasiva.push(r.idRenovacion);
      });

      const from = {
        idRenovaciones: `${cadenaMasiva}`,
      };

      console.log(from);
      this.axios.put(`Renovacion/CambioEstadoGeneral`, from).then((r) => {
        console.log(r.data);
        if(r.data){
        this.Renovaciones();

        }
      });
    },

    quitarCampos() {
      // const from = { cadenaRenovacion: `${this.Totalkit}` };
      // this.axios.put("Renovacion/EstadosMasivos", from).then((r) => {
      //   console.log(r.data);
      //   this.Renovaciones();
      // });
      // this.checkcitos = !this.checkcitos
      console.log("hola");
    },

    CargaTrabajadores() {
      const usuario = localStorage.getItem("userId");
      this.axios
        .get(`Renovacion/CanTrabajadores?idUsuario=${usuario}`)
        .then((r) => {
          if (r.status == 200) {
            this.reporteRenovacion();
            if (r.data.canTrabajadores == "0") {
              Swal.fire(`No se cargo ningún trabajador`, "", "success");
            } else if (r.data.canTrabajadores == "1") {
              Swal.fire(
                `Se registro ${r.data.canTrabajadores}  trabajador`,
                "",
                "success"
              );
            } else {
              Swal.fire(
                `Se registraron ${r.data.canTrabajadores}  trabajadores`,
                "",
                "success"
              );
            }
          }

          this.Renovaciones();
        });
    },

    resetPagina() {
      this.pag = 1;
      this.NUM_RESULTS = 10;
      this.noRetroceder = true;
      this.noAvanzar = false;
    },

    fetchItems() {
      // Se usa filtrado local desde @input
    },

    fetchApellido() {
      // Se usa filtrado local desde @input
    },

    fetchSubSubCentro() {
      // Se usa filtrado local desde @input
    },

    MarcarSSC() {
      const targetItems = this.itemsFiltrados.length > 0 ? this.itemsFiltrados : this.Items;
      targetItems.map((r) => {
        if (!r.renAccionReg) { // Usar renAccionReg
          this.TotalSsc.push(r.idRenovacion);
        }
      });

      const from = {
        idRenovaciones: `${this.TotalSsc}`,
      };

      console.log(from);
      this.axios.put(`Renovacion/CambioEstadoGeneral`, from).then((r) => {
        console.log(r.data);
        this.SubSubCentro = "";

        this.Renovaciones();
      });
    },

    Indi() {
      this.$router.push("/RegistroDeRenovaciones");
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    filtro() {
      this.filter = this.filtradoAntes;
    },

    CentroCostoMasivo(event) {
      this.idEmpresaMasivo = event.target.value;
      this.axios
        .get(
          `Ccosto/CentroxTrabajador?idEmpresa=${event.target.value}&dniUser=${this.dniUsuario}`
        )
        .then((r) => {
          this.CentroDeCostoMasivo = r.data;
          console.log(r.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    SubCentroCostoMasivo(event) {
      this.cenCodigoCentroMasivo = event.target.value;
      console.log(event.target.value);
      this.axios
        .get(
          `SubCentro/SubCxTrabajador?codCenCosto=${event.target.value}&dniUser=${this.dniUsuario}&idEmpresa=${this.idEmpresaMasivo}`
        )
        .then((r) => {
          this.SubCentroDeCostoMasivo = r.data;
          console.log(r.data);
        });
    },

    SubSubCentroDeCostosMasivo(event) {
      this.cenCodigoSubCentroMasivo = event.target.value;
      console.log(event.target.value);
      this.axios
        .get(
          `SubSubCentro/SScxTrabajador?idEmpresa=${this.idEmpresaMasivo}&dniUser=${this.dniUsuario}&codCentro=${this.cenCodigoCentroMasivo}&codSubCentro=${event.target.value}`
        )
        .then((r) => {
          this.SubSubCentroDeCostoMasivo = r.data;
          console.log(r.data);
        });
    },

    SubSubCentroCostosMandaMasivo(event) {
      this.cenCodigoSubSubCemtroMasivo = event.target.value;
      console.log(event.target.value);
    },

    PuestoMasivo(event) {
      this.idPuestoMasivo = event.target.value;
      console.log(event.target.value);
    },

    CargaMasiva() {
      this.Items.map((respuesta) => {
        // console.log(respuesta.fechaIniContrato)
        if (respuesta.accionRen == true) {
          this.Totalkit.push(respuesta.idRen);
          // this.fechaFinRen.push(respuesta.fechaIniContrato)
        }
      });

      console.log(this.Totalkit);
      // const from = {
      //   cadenaRenovacion: `${this.Totalkit}`,
      //   idEmpresa: this.idEmpresaMasivo,
      //   renCodCC: this.cenCodigoCentroMasivo,
      //   renCodScc: this.cenCodigoSubCentroMasivo,
      //   renCodSscc: this.cenCodigoSubSubCemtroMasivo,
      //   idPuesto: this.idPuestoMasivo,
      //   renSueldo: this.sueldoMasivo,
      //   fechaIniContrato: this.fechaIniMasivo,
      //   fechaFinContrato: this.fechaFinMasivo,
      // };

      const from = {
        cadenaRenovacion: `${this.Totalkit}`,
        idEmpresa: 0,
        renCodCC: "",
        renCodScc: "",
        renCodSscc: "",
        idPuesto: this.idPuestoMasivo,
        renSueldo: this.sueldoMasivo,
        fechaFinContrato: this.fechaFinMasivo,
      };
      // fechaIniContrato: this.fechaIniMasivo,

      console.log(from);

      this.axios.put("/Renovacion/ModificarRenMasivo", from).then((r) => {
        console.log(r.data);
        if (r.data == true) {
          this.Renovaciones();
          this.Totalkit = [];
          Swal.fire(`Se Renovaron los trabajadores`, "", "success");
        }
      });
    },
    actualizarEstado(items) {
      // console.log(items.renAccionReg);
      this.from.idRenovacion = items.idRenovacion;
      if (items.renAccionReg == true) { // Usar renAccionReg
        this.colorRenovacion = items.idRenovacion;
      } else {
        this.colorRenovacion = "";
      }

      this.axios.put("Renovacion/ModificarAccionxRen", this.from).then((r) => {
        console.log(r);
        this.BuscarAccionRenMasivo(); // Actualizar estado del botón general

        // Lógica para mostrar panel masivo y scroll
        if (this.conteoMarcados > 1) {
          this.opcion = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          this.opcion = false;
        }
      });
    },

    retroceso() {
      if (this.NUM_RESULTS === 10) {
        this.noRetroceder = true;
      } else {
        this.NUM_RESULTS -= 10;
        this.pag -= 1;
        this.noAvanzar = false;
        this.noRetroceder = false;
      }
    },

    aumentar() {
      this.NUM_RESULTS += 10;
      this.pag += 1;
      if (this.NUM_RESULTS > 10) {
        this.noRetroceder = false;
      } else {
        this.noRetroceder = true;
      }
      if (this.NUM_RESULTS >= this.itemsFiltrados.length) {
        this.noAvanzar = true;
      }
    },
  },
};
</script>

<style scoped>
select {
  margin-top: 0px;
  padding: 0px;
}

label {
  padding: 0px;
}

.tamaño {
  font-size: 0.75rem;
}

input[type="checkbox"] {
  padding: 0px;
  height: auto;
}

input[type="date"] {
  padding: 0px;
  height: auto;
}

input[type="text"] {
  min-width: 150px;
  padding: 0px;
}

strong {
  font-size: 1.64rem;
  color: black;
}

.reducirTamaño {
  font-size: 0.65rem;
}

/* .table,
thead,
tr {
  background: #0080c8;
  text-align: justify;
} */

.text-left {
  text-align: left;
}

/* select {
  min-width: 60px;
  padding-right: 5px;
  text-align: center;
} */

.bg-solimano {
  background: #0080c8;
}

.texto-color {
  color: #002c5d;
  font-size: 2.155rem;
  font-weight: 700;
}

.oscuro {
  font-weight: 700;
}

.tituloColor {
  color: #0080c8;
  font-weight: 700;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  text-decoration: underline;
}

.btn-solimano {
  background: #0080c8;
}
</style>
